// ============================================================
// PAYMENT PLANS PAGE
// ============================================================

import { PaymentPlansFilters } from '../../components/payment-plans/PaymentPlansFilters';
import { PaymentPlansKPIs } from '../../components/payment-plans/PaymentPlansKPIs';
import { PaymentPlansPagination } from '../../components/payment-plans/PaymentPlansPagination';
import { PaymentPlansTable } from '../../components/payment-plans/PaymentPlansTable';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';
import { usePaymentPlansAdmin } from '../../hooks/usePaymentPlansAdmin';

export function PaymentPlansPage() {
  const {
    paymentPlans,
    loading,
    error,
    stats,
    statusFilter,
    searchQuery,
    hasActiveFilters,
    pagination,
    updateSearch,
    updateStatusFilter,
    resetFilters,
    setPage,
  } = usePaymentPlansAdmin();

  if (loading) {
    return (
      <div className="space-y-6 pb-12">
        <PageHeader />
        <LoadingSpinner message="Chargement des plans de paiement..." submessage="Veuillez patienter" size="md" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-6 pb-12">
        <PageHeader />
        <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
          <p className="text-red-600 font-medium mb-2">Erreur lors du chargement</p>
          <p className="text-red-500 text-sm">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6 pb-12">
      <PageHeader />

      <PaymentPlansKPIs stats={stats} />

      <div className="flex flex-col gap-4">
        <PaymentPlansFilters
          search={searchQuery}
          onSearchChange={updateSearch}
          statusFilter={statusFilter}
          onStatusChange={updateStatusFilter}
          onReset={resetFilters}
          hasActiveFilters={hasActiveFilters}
          filteredCount={pagination.total}
          totalCount={stats.total}
        />

        <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
          <PaymentPlansTable paymentPlans={paymentPlans} hasActiveFilters={hasActiveFilters} onReset={resetFilters} />
          <PaymentPlansPagination
            totalPages={pagination.totalPages}
            currentPage={pagination.currentPage}
            onPageChange={setPage}
            filteredCount={pagination.total}
          />
        </div>
      </div>
    </div>
  );
}

function PageHeader() {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Plans de Paiement</h1>
        <p className="text-slate-500 mt-1">Gérez les paiements échelonnés et suivez les mensualités</p>
      </div>
    </div>
  );
}
